(function(){
  'use strict';
  var VERSION = 'p11dz116-runtime-stabilization-passive-social-route-v1';
  if (window.DSDRuntimeStabilizer && window.DSDRuntimeStabilizer.version === VERSION) return;

  function now(){ try { return new Date().toISOString(); } catch(e){ return ''; } }
  function registry(){ return window.DSDRegistry || window.DSDRuntimeRegistry || null; }
  function claim(surface, owner, meta){
    try { var r = registry(); if (r && typeof r.claim === 'function') r.claim(surface, owner, meta || {}); } catch(e) {}
  }
  function event(code, detail){
    try {
      var r = registry();
      if (r && typeof r.event === 'function') r.event(code, detail || {});
      else if (r && typeof r.track === 'function') r.track(code, detail || {});
    } catch(e) {}
  }

  var state = {
    version: VERSION,
    startedAt: now(),
    route: location.pathname,
    socialRoute: /\/pages\/(users|user-profile|wishlist)/.test(location.pathname),
    resize: { raw: 0, emitted: 0, lastHeight: 0, lastWidth: 0, lastAt: null },
    header: { found: false, lastSignature: '', deduped: 0, checks: 0, lastAt: null },
    viewportObserved: 0,
    body: { lastSignature: '', deduped: 0, checks: 0, lastAt: null }
  };

  function signature(el){
    if (!el) return '';
    return [el.className || '', el.getAttribute('style') || '', el.getAttribute('aria-hidden') || '', el.getAttribute('open') || ''].join('|');
  }

  function stabilizeViewportObservers(){
    var nodes = document.querySelectorAll('[data-inviewport]');
    var count = 0;
    nodes.forEach(function(el){
      if (el.dataset.dsdViewportStable === 'true') return;
      el.dataset.dsdViewportStable = 'true';
      count++;
    });
    if (count) {
      state.viewportObserved += count;
      claim('viewport-animation:stable-observed', 'RuntimeStabilizer', { version: VERSION, added: count, total: state.viewportObserved });
    }
  }

  function stabilizeHeader(){
    var header = document.querySelector('.section-header');
    if (!header) return;
    state.header.found = true;
    state.header.checks++;
    var sig = signature(header);
    if (sig === state.header.lastSignature) {
      state.header.deduped++;
      return;
    }
    state.header.lastSignature = sig;
    state.header.lastAt = now();
    if (header.dataset.dsdRuntimeStable !== VERSION) header.dataset.dsdRuntimeStable = VERSION;
  }

  function stabilizeBody(){
    if (!document.body) return;
    state.body.checks++;
    var sig = signature(document.body);
    if (sig === state.body.lastSignature) {
      state.body.deduped++;
      return;
    }
    state.body.lastSignature = sig;
    state.body.lastAt = now();
    if (document.body.dataset.dsdRuntimeStable !== VERSION) document.body.dataset.dsdRuntimeStable = VERSION;
  }

  var resizeTimer = null;
  function onResize(){
    state.resize.raw++;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function(){
      var w = window.innerWidth || 0;
      var h = (window.visualViewport && window.visualViewport.height) || window.innerHeight || 0;
      if (Math.abs(w - state.resize.lastWidth) < 2 && Math.abs(h - state.resize.lastHeight) < 8) return;
      state.resize.lastWidth = w;
      state.resize.lastHeight = h;
      state.resize.lastAt = now();
      state.resize.emitted++;
      event('RUNTIME_RESIZE_STABILIZED', { version: VERSION, width: w, height: h, raw: state.resize.raw, emitted: state.resize.emitted });
    }, 180);
  }

  function installResizeGovernance(){
    window.addEventListener('resize', onResize, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', onResize, { passive: true });
    claim('resize-governance:debounced', 'RuntimeStabilizer', { version: VERSION, route: state.route, debounceMs: 180 });
  }

  var intervalId = null;
  function installMutationWatch(){
    if (state.socialRoute) {
      claim('mutation-governance:header-body-watch', 'RuntimeStabilizer', {
        version: VERSION,
        targets: 0,
        mode: 'disabled-on-social-routes',
        reason: 'avoid amplifying body/header class/style churn already reported by diagnostics'
      });
      return;
    }
    if (!('MutationObserver' in window)) return;
    var targets = [];
    var header = document.querySelector('.section-header');
    if (header) targets.push(header);
    if (document.body) targets.push(document.body);
    var obs = new MutationObserver(function(){
      stabilizeHeader();
      stabilizeBody();
    });
    targets.forEach(function(el){
      try { obs.observe(el, { attributes: true, attributeFilter: ['class','style','aria-hidden','open','data-state'] }); } catch(e) {}
    });
    claim('mutation-governance:header-body-watch', 'RuntimeStabilizer', { version: VERSION, targets: targets.length });
  }

  function boot(){
    stabilizeViewportObservers();
    if (!state.socialRoute) {
      stabilizeHeader();
      stabilizeBody();
    } else {
      claim('runtime-stabilizer:social-route-passive-mode', 'RuntimeStabilizer', {
        version: VERSION,
        route: state.route,
        bodyHeaderAttributeWrites: false,
        periodicBodyHeaderStabilization: false
      });
    }
    installResizeGovernance();
    installMutationWatch();
    intervalId = setInterval(function(){
      stabilizeViewportObservers();
      if (!state.socialRoute) { stabilizeHeader(); stabilizeBody(); }
    }, 3000);
    window.addEventListener('pagehide', function(){ try { clearInterval(intervalId); } catch(e) {} }, { once:true });
    claim('runtime-stabilizer:ready', 'RuntimeStabilizer', { version: VERSION, route: state.route, socialRoute: state.socialRoute });
    event('RUNTIME_STABILIZER_READY', { version: VERSION, route: state.route, passiveSocialRoute: state.socialRoute });
  }

  window.DSDRuntimeStabilizer = {
    version: VERSION,
    state: state,
    snapshot: function(){ return JSON.parse(JSON.stringify(state)); },
    stabilizeHeader: stabilizeHeader,
    stabilizeViewportObservers: stabilizeViewportObservers
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
